import React from 'react';
import { Check, Loader2, X } from 'lucide-react';

// Horizontal agent pipeline stepper.
// steps: [{ label, status: 'done'|'active'|'pending'|'error', meta? }]
export default function Pipeline({ steps = [] }) {
  return (
    <div className="flex items-stretch overflow-x-auto">
      {steps.map((s, i) => {
        const done = s.status === 'done';
        const active = s.status === 'active';
        const error = s.status === 'error';
        return (
          <div key={i} className="flex items-center min-w-0">
            <div className="flex flex-col items-center text-center px-1">
              <div
                className={`relative h-7 w-7 rounded-full flex items-center justify-center text-[11px] font-semibold
                ${done ? 'bg-emerald-500 text-white' : ''}
                ${active ? 'bg-brand-600 text-white dh-ring' : ''}
                ${error ? 'bg-rose-500 text-white' : ''}
                ${!done && !active && !error ? 'bg-slate-100 text-slate-400 border border-slate-200' : ''}`}
              >
                {done && <Check className="h-3.5 w-3.5" />}
                {active && <Loader2 className="h-3.5 w-3.5 animate-spin" />}
                {error && <X className="h-3.5 w-3.5" />}
                {!done && !active && !error && <span>{i + 1}</span>}
              </div>
              <div className={`mt-1.5 text-[11px] leading-tight whitespace-nowrap ${active ? 'text-brand-700 font-semibold' : done ? 'text-slate-700' : 'text-slate-400'}`}>
                {s.label}
              </div>
              {s.meta && <div className="text-[10px] text-slate-400">{s.meta}</div>}
            </div>
            {i < steps.length - 1 && (
              <div className={`h-0.5 w-8 md:w-14 mb-5 rounded-full ${done ? 'bg-emerald-300' : 'bg-slate-200'}`} />
            )}
          </div>
        );
      })}
    </div>
  );
}
